module.exports = __webpack_public_path__ + "img/logo.haywood.8509929a.png";